<template>
  <div class="sso-buttons">
    <GoogleSignOn :theme="theme" :return-url="returnUrl" />
  </div>
</template>

<script>
import GoogleSignOn from "@/components/GoogleSignOn.vue";

export default {
  name: "SingleSignOn",
  components: {
    GoogleSignOn,
  },
  props: {
    theme: {
      type: String,
      default: "primary",
    },
    returnUrl: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.sso-buttons {
  padding: 5px 0 30px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba($color-grey, 0.2);
}
</style>
